module.exports = __webpack_public_path__ + "img/group-3901@3x.0d4321ba.png";